<script setup lang="ts">
import { useRouter } from 'vue-router';
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';

defineProps<{ category: string }>();

const router = useRouter();

async function onOpenCategoryTransactions(e: CustomEvent) {
  const { category } = e.detail;
  await router.push(`/banking/budget-analysis/category/${category}/transactions`);
}
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <!-- eslint-disable vue/attribute-hyphenation -->
    <ba-budget-analysis-parent-category
      :token="token"
      :parentCategory="category"
      @emitError="(e) => onEmitError(e, 'ba-budget-analysis-parent-category')"
      @openCategoryTransactions="onOpenCategoryTransactions"
    />
  </BankingWrapper>
</template>
